<div>
    <div class="row">
      <div class="col-12 mb-0">
        <h4 class="mb-2 py-1 font-header-1">ICD10 Code</h4>
      </div>
    </div>
    <!-- List -->
    <div class="row ">
      <div class="col">
        <div class="card border-0 shadow">
          <div class="card-body  widget-body pb-0 pt-2 mb-4">
            <div class="row alert ms-3 me-3 alert-warning text-dark" *ngIf="deleteAlert">
              <strong>{{ deleteError }}</strong>
            </div>
            <div class="row mt-2">
              <div class="col-lg-4">
                <label class="fw-bold">Filter By</label>
                <select [(ngModel)]="SearchColumn.key" class="form-select" (ngModelChange)="setDefaultValue($event)">
                  <option *ngFor="let item of filterItems" [ngValue]="item.key">{{ item.value }}</option>
                </select>
              </div>
              <div class="col-lg-4" *ngIf="SearchColumn.key">
                <label class="fw-bold">{{ SearchColumn.value }}</label>
                <input type="text" class="form-control" (keydown)="onKeydown($event)" [(ngModel)]="SearchText" />
              </div>
              <div class="col-lg-4">
                <label></label>
                <button type="button" class="btn btn-primary btn-sm mt-2" (click)="Search()">Apply</button>
              </div>
            </div>
            <div class="row mb-2 mt-2 ps-3 pe-3">
              <!-- Add ICD10 Code -->
              <div class="col-lg-8">
                <button type="button" class="btn btn-primary btn-sm" data-bs-toggle="modal" data-bs-target="#modal" *ngIf="fp.icd10create"
                  (click)="IcdCreateupdate('new')"  >Add ICD10 Code</button>
              </div>
              <!-- Refresh -->
              <div class="col-lg-4 text-end">
                <button type="button" class="btn btn-primary btn-sm" (click)="Refresh()">
                  <i class="fa fa-repeat"></i> Refresh
                </button>
              </div>
            </div>
            <div class="row ps-3 pe-3">
              <div class="col-lg-12">
                <ejs-grid #grid [dataSource]="data | async" [allowSorting]="true" [allowResizing]="true"
                  [allowPaging]="true" [pageSettings]="initialPage" [filterSettings]="filterSettings"
                  [allowFiltering]="true" (actionBegin)="onActionComplete($event)" [showColumnChooser]="true"
                  (dataStateChange)="dataStateChange($event)" (resizeStop)="onResize($event)">
                  <e-columns>
                    <e-column minWidth="100" *ngIf="!clientview" headerText="Actions" uid="action" textAlign="center"
                      [showInColumnChooser]="false">
                      <ng-template #template let-data *ngIf="!clientview">
                        <button class="btn btn-edit-table" data-bs-toggle="modal" data-bs-target="#modal" *ngIf="fp.icd10update"
                          (click)="IcdCreateupdate('edit');icdDetails(data)"
                         ><i class="fa fa-edit"></i></button>&nbsp;
                          <button class="btn btn-delete-table" data-bs-toggle="modal" data-bs-target="#deletemodal" *ngIf="fp.icd10delete"
                        (click)="icdDetails(data)"  ><i 
                          class="fa fa-trash"></i></button>
                      </ng-template>
                    </e-column>
                    <e-column minWidth=100 field="code" headerText="Code">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth=100 field="icD10Level" headerText="ICD10 Level" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth=100 field="icD10Description" headerText="ICD10 Description" type="string">
                      <ng-template #filterTemplate let-data>
                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                      </ng-template>
                    </e-column>
                    <e-column minWidth=100 *ngIf="clientview" headerText="Select" uid="action" textAlign="center"
                      [showInColumnChooser]='false'>
                      <ng-template #template let-data *ngIf="clientview">
                        <input type="radio" (change)="valueselect(data)">
                      </ng-template>
                    </e-column>
                    <e-column width="50" [showInColumnChooser]='false'>
                      <ng-template #headerTemplate let-data>
                        <div class="d-none d-lg-block">
                          <span id='show' (click)='show()'><i class="fa fa-cog fa-lg" aria-hidden="true"> </i></span>
                        </div>
                      </ng-template>
                    </e-column>
                  </e-columns>
                </ejs-grid>
              </div>
            </div>
            <div *ngIf="Icd10DataList.length === 0" class="text-center text-danger">
              <p>No data available</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <span id="openModal1" data-bs-target="#modal" data-bs-toggle="modal"></span>
    <div class="modal fade" id="modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"
      data-bs-backdrop="static">
      <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
          <div class="row alert ml-3 mt-2 mr-3 alert-warning" *ngIf="saveAlert==true">
            <strong>{{saveError}}</strong>
          </div>
          <div class="modal-header">
            <h5 class="modal-title font-header" id="exampleModalLabel">
              <span *ngIf="ModelType =='new'"> Create ICD10 Code</span> <span *ngIf="ModelType =='edit'">Update ICD10
                Code</span>
            </h5>
            <button type="button" class="btn-close" (click)="closeCreateICD10()"></button>
          </div>
          <div class="modal-body">
            <form [formGroup]="icd10Form">
              <div class="row">
                <div class="col-lg-5">
                  <label>Code<sup class="super-script">&nbsp; *</sup>
                  </label>
                </div>
                <div class="col-lg-7">
                  <input type="text" class="form-control" formControlName="code" [(ngModel)]="icd10.code"
                    (ngModelChange)="checkpopup('code')">
                </div>
              </div>
              <span class="help-block text-danger text-center"
                *ngIf="!icd10Form.get('code').valid && icd10Form.get('code').touched ">
                <p>Please Enter Code</p>
              </span>
              <div class="row">
                <div class="col-lg-5">
                  <label>ICD10 Level </label>
                </div>
                <div class="col-lg-7">
                  <input type="text" class="form-control" formControlName="icD10Level" [(ngModel)]="icd10.icD10Level"
                    (ngModelChange)="checkpopup('icD10Level')">
                </div>
              </div>
  
              <div class="row">
                <div class="col-lg-5">
                  <label>ICD10 Desc.</label>
                </div>
                <div class="col-lg-7">
                  <input type="text" class="form-control" formControlName="icD10Description"
                    [(ngModel)]="icd10.icD10Description" (ngModelChange)="checkpopup('icD10Description')">
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button class="btn blue-btn btn-sm" (click)="SaveOrUpdateIcd10()" [disabled]="!icd10Form.valid"><span
                *ngIf="ModelType =='new'"> Save &
                Close</span> <span *ngIf="ModelType =='edit'">Update & Close</span> </button>
            <button class="btn blue-btn btn-sm" (click)="closeCreateICD10()" id="openBtn">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <span id="openModal2" data-bs-target="#deletemodal" data-bs-toggle="modal"></span>
  <div class="modal fade" id="deletemodal">
    <div class="modal-dialog delete-zip" role="document">
  
      <div class="modal-content">
  
        <div class="modal-header">
  
          <h5 class="modal-title font-header">Delete Record</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <label>Do you want to delete this record ?</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm" (click)="deleteIcd10()">Delete</button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
  
  
  <span id="openModal3" data-bs-target="#CloseModal" data-bs-toggle="modal"></span>
  <div class="modal" id="CloseModal">
    <div class="modal-dialog modal-sm">
      <div class="modal-content">
  
        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title">Close</h4>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true"></span>
          </button>
        </div>
  
        <!-- Modal body -->
        <div class="modal-body">
          You want to close without save?
        </div>
  
        <!-- Modal footer -->
        <div class="modal-footer">
          <button type="button" class="btn blue-btn" (click)="cancelYes()">Yes</button>
          <button type="button" class="btn blue-btn" data-bs-dismiss="modal">No</button>
        </div>
  
      </div>
    </div>
  </div>